import {WithdrawalRepository} from "../../domain/types";
import {WithdrawalRepositoryV2} from "./repository.v2";

export type {WithdrawalRepository} from "../../domain/types";

/**
 * Creates the WithdrawalRepository.
 *
 * v1 has been decommissioned; v2 is the only implementation.
 *
 * @example
 * const repository = createWithdrawalRepository();
 * const response = await repository.initiateWithdrawal({ amount: 1000 });
 */
export const createWithdrawalRepository = (): WithdrawalRepository => {
  return new WithdrawalRepositoryV2();
};
